import { Container } from '../../odie';

import { app } from '../app';
import { IAnimation } from '../../lib/pattern/IAnimation';
import { ParticleEmitter } from '../particles/ParticleEmitter';
import { getMatch2AssetPath } from '../util/assets';

/*
    crate breaking animation
*/
export class CrateBreakAnimation extends Container implements IAnimation {
  public static assets(): string[] {
    return ['fx.crate'];
  }

  public async start(): Promise<void> {
    // create debris emitter
    const debrisEmitter = this.createDebrisEmitter();

    // animate debris and blast
    await this.animateDebris(debrisEmitter);
  }

  public stop() {}

  private async animateDebris(debris: ParticleEmitter) {
    // spawn debris
    this.addChild(debris.view);

    // start
    await debris.start();

    // despawn debris
    this.removeChild(debris.view);
  }

  private createDebrisEmitter(): ParticleEmitter {
    return app.particles.create({
      textures: [
        getMatch2AssetPath('fx.crate/fx.crate.particle1.png'),
        getMatch2AssetPath('fx.crate/fx.crate.particle2.png'),
        getMatch2AssetPath('fx.crate/fx.crate.particle3.png'),
        getMatch2AssetPath('fx.crate/fx.crate.particle4.png'),
      ],
      rate: 0,
      limit: 10,
      emitterDuration: 0,
      duration: 2.5,
      velocity: { x: 0, y: -200 },
      scale: [
        { x: 0.6, y: 0.6 },
        { x: 1, y: 1 },
      ],
      behaviors: [
        { type: 'explode', magnitude: [60, 120] },
        { type: 'gravity', gravity: { x: 0, y: 1000 } },
        { type: 'scale', to: 0 },
        { type: 'kinematic' },
      ],
    });
  }
}
